import Quotes from "../../components/Admin/Quotes";

export default function AdminQuotes() {
  return <Quotes />;
}
